'use strict';
import Megatron from '@stencil/megatron';
import {apiConfig} from '@stencil/hotels-config';

export async function pushToNewrelic(queryString: string) {
  try {
    const url = `${apiConfig.__DEXTER__}/common/newrelic/?${queryString}`;

    await Megatron({
      name: 'Push To New Relic API',
      type: 'GET',
      url,
      credentials: 'same-origin',
      headers: {'Content-Type': 'charset=UTF-8'},
    });
  } catch (err) {
    // pushToNewrelic(`serviceApp=avatarClient&errorMsg=${err}`);
    console.trace(err);
  }
}

export default pushToNewrelic;
